export const createPromoString = (sku: string, promocode: string): string | undefined => {
  if (!sku && !promocode) {
    return null;
  }
  if (!promocode) {
    return sku;
  }
  if (!sku) {
    return promocode;
  }
  return `${sku} ${promocode}`;
};
